import MiniProgramPage from 'D:/小小程序员/项目/medical-management/OPO-uni/pages/featured/expert.vue'
wx.createPage(MiniProgramPage)